import type { ServerModule } from '../ServerWorkflowType';

export const modules: ServerModule[] = [
  {
    author: null,
    configId: 'com.wolterskluwer.gpo.contentbus.modules.validation',
    description:
      'Validates documents according to PCI, HTML5 and RDF validation rules, Java 11 version',
    iconId: null,
    id: 281,
    instances: [],
    isSystem: false,
    name: 'Validation',
    parameters: [
      {
        default: 'http://10.232.41.72:8480/content-validation-odata-war/',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 4605,
        name: 'Validation Service endpoint',
        required: true,
        textId: 'endpointOSA3',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 4606,
        name: 'Plan name',
        required: true,
        textId: 'validationName',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 4607,
        name: 'Plan version',
        required: true,
        textId: 'validationVersion',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 4608,
        name: 'Input mimetype',
        required: true,
        textId: 'validationMimetype',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: 'false',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 4609,
        name: 'Use packaging',
        required: true,
        textId: 'usePackaging',
        tooltip: null,
        type: 'BOOLEAN',
        value: null,
      },
      {
        default: 'false',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 4610,
        name: 'Continue if failed',
        required: true,
        textId: 'continueIfFailed',
        tooltip: null,
        type: 'BOOLEAN',
        value: null,
      },
      {
        default: 'false',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 4611,
        name: 'Send validation report (if fail)',
        required: true,
        textId: 'sendReport',
        tooltip: null,
        type: 'BOOLEAN',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: 'useReportingService',
        dependsValue: 'Yes',
        dynamicValues: false,
        id: 4612,
        name: 'Report Service base url',
        required: true,
        textId: 'reportingBaseUrl',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: 'useReportingService',
        dependsValue: 'Yes',
        dynamicValues: false,
        id: 4613,
        name: 'Report System Name',
        required: true,
        textId: 'reportingSystemName',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: 'ApolloClient',
        defaultText: null,
        dependsId: 'useReportingService',
        dependsValue: 'Yes',
        dynamicValues: false,
        id: 4614,
        name: 'Report System OAuth clientId',
        required: true,
        textId: 'reportingOauthClientId',
        tooltip: null,
        type: 'SECURE',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: 'useReportingService',
        dependsValue: 'Yes',
        dynamicValues: false,
        id: 4615,
        name: 'Report System OAuth clientSecret',
        required: true,
        textId: 'reportingOauthClientSecret',
        tooltip: null,
        type: 'SECURE',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: 'useReportingService',
        dependsValue: 'Yes',
        dynamicValues: false,
        id: 4616,
        name: 'Report System OAuth tokenUrl',
        required: true,
        textId: 'reportingOauthTokenUrl',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: 'yyyyMMdd',
        defaultText: null,
        dependsId: 'useReportingService',
        dependsValue: 'Yes',
        dynamicValues: false,
        id: 4617,
        name: 'DateFormat for the processId postfix',
        required: false,
        textId: 'processIdDateFormat',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: 'UTC',
        defaultText: null,
        dependsId: 'useReportingService',
        dependsValue: 'Yes',
        dynamicValues: false,
        id: 4618,
        name: 'TimeZone for the processId postfix',
        required: false,
        textId: 'processIdTimeZone',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: 'No',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 4619,
        name: 'Use Reporting Service',
        required: true,
        textId: 'useReportingService',
        tooltip: null,
        type: 'ENUM',
        value: 'Yes|No',
        valueAsArray: ['Yes', 'No'],
        values: ['Yes', 'No'],
      },
    ],
    slave: null,
    textId: 'validation',
    version: '3.5.3',
  },
  {
    author: null,
    configId: 'com.wolterskluwer.gpo.contentbus.modules.conversion',
    description: 'Converts documents.',
    iconId: null,
    id: 592,
    instances: [],
    isSystem: false,
    name: 'Conversion',
    parameters: [
      {
        default:
          'https://conversion-service:8443/content-conversion-odata-war/',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 12_514,
        name: 'Content Conversion endpoint',
        required: true,
        textId: 'endpointOSA3_4',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: 'smartchart-pcing2interchange',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 12_515,
        name: 'Plan name',
        required: true,
        textId: 'conversionName',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: '1.0.0',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 12_516,
        name: 'Plan version',
        required: true,
        textId: 'conversionVersion',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: 'application/zip',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 12_517,
        name: 'Input mimetype',
        required: true,
        textId: 'conversionMimetype',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 12_518,
        name: 'Custom parameters',
        required: false,
        textId: 'custom',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
    ],
    slave: null,
    textId: 'conversion',
    version: '5.2.0',
  },
  {
    author: null,
    configId: 'com.wolterskluwer.gpo.contentbus.modules.wait',
    description: 'Wait, Java 17 version',
    iconId: null,
    id: 492,
    instances: [],
    isSystem: false,
    name: 'Wait',
    parameters: [
      {
        default: '300',
        defaultText: 'Enter the number of seconds to wait',
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 8392,
        name: 'Seconds',
        required: true,
        textId: 'seconds',
        tooltip:
          "\n                    This property defines the pause duration in seconds. The default value is 300 seconds\n\n                    The property's database constraint is MEDIUMTEXT (up to 16 MB)\n                ",
        type: 'INTEGER',
        value: null,
      },
    ],
    slave: null,
    textId: 'wait',
    version: '4.1.0',
  },
  {
    author: null,
    configId:
      'com.wolterskluwer.gpo.contentbus.modules.apollo.alfresco.import.raw',
    description: 'Used for bulk in-place import to Alfresco repository',
    iconId: null,
    id: 765,
    instances: [],
    isSystem: false,
    name: 'Alfresco Import RAW content',
    parameters: [
      {
        default: '',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 20_444,
        name: 'Alfresco Site ID',
        required: true,
        textId: 'siteId',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 20_445,
        name: 'Target Folder',
        required: false,
        textId: 'targetFolder',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
    ],
    slave: null,
    textId: 'apollo-alfresco-import-raw',
    version: '5.0.2',
  },
  {
    author: null,
    configId:
      'com.wolterskluwer.gpo.contentbus.modules.apollo.alfresco.import.raw',
    description: 'Used for bulk in-place import to Alfresco repository',
    iconId: null,
    id: 309,
    instances: [],
    isSystem: false,
    name: 'Alfresco Import RAW content',
    parameters: [
      {
        default: '',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 6069,
        name: 'Alfresco Site ID',
        required: true,
        textId: 'siteId',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
      {
        default: '',
        defaultText: null,
        dependsId: null,
        dependsValue: null,
        dynamicValues: false,
        id: 6070,
        name: 'Target Folder',
        required: false,
        textId: 'targetFolder',
        tooltip: null,
        type: 'STRING',
        value: null,
      },
    ],
    slave: null,
    textId: 'apollo-alfresco-import-raw',
    version: '4.0.0-java17-parent-4.5.0',
  },
  {
    author: null,
    configId: 'com.wolterskluwer.gpo.contentbus.modules.donothing',
    description: 'Does nothing, used as a placeholder step.',
    iconId: null,
    id: 101,
    instances: [],
    isSystem: true,
    name: 'Do nothing',
    parameters: [],
    slave: null,
    textId: 'do-nothing',
    version: '1.0.0',
  },
];

